module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.6535/assets/images/quota-path.jpg"